import type { TabConfig } from 'client/js/main/components/nav/neoTabsConfig';

export const ROI_HUB_PAGE_TITLE = 'ROI Hub';

const ROI_HUB_NAV_TABS: TabConfig[] = [
  {
    id: 'mui-tab-roi-overview',
    route: '/ads/roi-hub/overview',
    label: 'Overview',
  },
  {
    id: 'mui-tab-connection-overview',
    route: '/ads/roi-hub/connections',
    label: 'Connections',
  },
  {
    id: 'mui-tab-file-ingestion',
    route: '/ads/roi-hub/import',
    label: 'Import',
  },
];

export const getRoiHubTabsConfig = (): TabConfig[] => {
  return ROI_HUB_NAV_TABS;
};
